import React, { useState } from 'react';
import Finished from "../common/Finished";
import { useFormikContext } from "formik";
import { DisabilityEmployeeFormValues } from "../../disability/DisabilityEmployeeFormValues";
import { useMutation } from "@apollo/client";
import { GENERATE_HIPAA_PDF_MUTATION } from "../../../Queries";
import { DateTime } from "luxon";
import Button from "../../button/Button";
import { base64ToPdfBlob } from "../../../service/Base64Pdf";

const EmployeeFinished = () => {
    const { initialValues, values } = useFormikContext<DisabilityEmployeeFormValues>();
    const [isDownloading, setIsDownloading] = useState(false);
    const [generateHipaaPdf] = useMutation(GENERATE_HIPAA_PDF_MUTATION);
    const showButton = initialValues.hipaaConsent !== undefined;

    const handleDownloadPdf = async () => {
        setIsDownloading(true);
        try {
            const hipaaPdfInput = {
                firstName: values.firstName,
                lastName: values.lastName,
                dateOfBirth: values.dateOfBirth,
                relationship: values.relationship,
                phoneNumber: values.phoneNumber,
                confidentialMessages: values.confidentialMessages,
                permissionContactName: values.permissionContactName,
                representativeAuthority: values.representativeAuthority,
                relationshipType: values.relationshipType,
                otherRelationshipDescription: values.otherRelationshipDescription,
                authorityDescription: values.authorityDescription,
                hipaaConsent: values.hipaaConsent,
                patientFirstName: values.patientFirstName,
                patientLastName: values.patientLastName,
                patientDateOfBirth: values.patientDateOfBirth,
                emailAddress: values.emailAddress,
                streetAddress: values.streetAddress,
                city: values.city,
                state: values.state,
                zipCode: values.zipCode,
                claimNumber: values.claimNumbers?.[0],
                signature: values.signature,
                signatureDate: values.signatureDate || DateTime.now().toFormat('MM/DD/yyyy')
            };

            const { data } = await generateHipaaPdf({
                variables: { hipaaPdfInput }
            });

            if (data?.generateHipaaPdf) {
                const pdfBlob = base64ToPdfBlob(data.generateHipaaPdf);
                if (pdfBlob) {
                    const url = URL.createObjectURL(pdfBlob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = 'Filled_HIPAA_Form.pdf';
                    link.click();
                    URL.revokeObjectURL(url);
                } else {
                    console.error('Generated HIPAA PDF blob was null or invalid');
                }
            }
        } catch (error) {
            console.error('Failed to download filled PDF:', error);
        } finally {
            setIsDownloading(false);
        }
    };

    return (
        <>
            <Finished headerText="You made it!"
                      submissionText="You have submitted the employee portion of the claim form. Medical information and information from your employer will need to be provided to complete your claim review. Additional information will be sent to the email address you provided. If you don't see our communication, please check your junk or spam folder."
                      actionsRight={
                         showButton && <div style={{ minWidth: '260px' }}>
                              <Button
                                  type="button"
                                  onClick={handleDownloadPdf}
                                  buttonContent={isDownloading ? 'Preparing PDF...' : 'Download Filled HIPAA (.pdf)'}
                              />
                              <div style={{ marginTop: '8px', fontSize: '14px', color: '#666' }}>
                                  Click to download a copy of the HIPAA form with your responses filled in
                              </div>
                          </div>
                      }/>
        </>
    )
};
export default EmployeeFinished;